module.exports = __webpack_public_path__ + "static/media/maze.c4f36022.png";